import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';
import * as util from 'notebook/tables/excess/Util';
import flatten from 'notebook/tables/excess/util/flatten';

export default {
  name: 'AND',
  shortDescription: 'Logical AND operator.',
  category: FunctionCategory.LOGIC,
  description:
    'Returns true if all of the provided arguments are logically true, and false if any of the provided arguments are logically false.',
  params: [
    {
      name: 'logical_expression',
      type: ArgType.any,
      description:
        'An expression or reference to a cell containing an expression that represents some logical value, i.e. TRUE or FALSE, or an expression that can be coerced to a logical value.',
    },
  ],
  repeatableLastParamType: ArgType.any,
  repeatableLastParamDescription: 'More expressions that represent logical values.',
  eval: (...operands): boolean => {
    operands = flatten(operands);
    // TODO(BNCH-114119): Coerce operands to booleans
    if (!operands.every((operand): operand is boolean => typeof operand === 'boolean')) {
      throw new util.ValueError(
        'Function AND parameter has wrong type. Its value should be either TRUE or FALSE.'
      );
    }
    return operands.every((x) => x);
  },
} satisfies EvaluablePrimitiveSpreadsheetFunction;
